import React, { useEffect, useState } from "react";
import Language from "../lib/Language";

type TTypeSettlingMessageProps = {
    style: {
        height?: number;
    };
};

const delayMs = 300;

const TypeSettlingMessage = (props: TTypeSettlingMessageProps) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), delayMs);
        return () => clearTimeout(timer);
    }, [delayMs]);

    if (!visible) {
        return null;
    }

    return (
        <div className="tooManyObjects typeSettling" style={props.style}>
            {Language.get("admin_loading")}
            <br />
        </div>
    );
};

export default TypeSettlingMessage;
